import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { ToastError, ToastInfo, ToastSuccess } from "components/Global/Toasts/Toasty";
import {
  defaultReturn,
  fillDictionary,
  makePayload,
  generateDefaultActions,
  requestSaga,
  handleCallback,
  subKeySaga
} from "shared-utility/store/utils/helpers";
import { downloadXLSFile } from "utils/api";

export const DEBT_VALUATION_UPDATE_DEBT_VALUATION_SETTINGS_FOR_LOAN = generateDefaultActions("DEBT_VALUATION_UPDATE_DEBT_VALUATION_SETTINGS_FOR_LOAN");
export const updateDebtValuationSettingsForLoan = (payload) => makePayload(DEBT_VALUATION_UPDATE_DEBT_VALUATION_SETTINGS_FOR_LOAN.value, payload);
function* updateDebtValuationSettingsForLoanSaga(payload) {
  const callback = handleCallback(payload);
  const url = "/debtValuation/updateDebtValuationSettingsForLoan";
  yield requestSaga(DEBT_VALUATION_UPDATE_DEBT_VALUATION_SETTINGS_FOR_LOAN, url, "POST", payload);
  yield callback();
}

export const DEBT_VALUATION_DOWNLOAD = generateDefaultActions("DEBT_VALUATION_DOWNLOAD");
export const downloadDebtValuationResults = (payload) => makePayload(DEBT_VALUATION_DOWNLOAD.value, payload);
function* downloadDebtValuationResultsSaga(payload) {
  try {
    const callback = handleCallback(payload);
    const url = "debtValuation/exportByCompanyId";
    yield call(downloadXLSFile, url, "POST", payload, "");
    yield callback();
  } catch (error) {
    yield put(DEBT_VALUATION_DOWNLOAD.createFailure(error));
  }
}

export const DEBT_VALUATION_DOWNLOAD_LOANID = generateDefaultActions("DEBT_VALUATION_DOWNLOAD_LOANID");
export const downloadDebtValuationResultsByLoanId = (payload) => makePayload(DEBT_VALUATION_DOWNLOAD_LOANID.value, payload);
function* downloadDebtValuationResultsByLoanIdSaga(payload) {
  try {
    const callback = handleCallback(payload);
    const url = "debtValuation/exportByLoanId";
    yield call(downloadXLSFile, url, "POST", payload, "");
    yield callback();
  } catch (error) {
    yield put(DEBT_VALUATION_DOWNLOAD_LOANID.createFailure(error));
  }
}

export const DEBT_VALUATION_GET_DEBT_VALUATION = generateDefaultActions("DEBT_VALUATION_GET_DEBT_VALUATION");
export const getDebtValuation = (payload) => makePayload(DEBT_VALUATION_GET_DEBT_VALUATION.value, payload);
function* getDebtValuationSaga(payload) {
  const callback = handleCallback(payload);
  const url = "/debtValuation/getByCompanyId";
  yield requestSaga(DEBT_VALUATION_GET_DEBT_VALUATION, url);
  yield callback();
}

export const DEBT_VALUATION_GET_COMPANY_GROUPS = generateDefaultActions("DEBT_VALUATION_GET_COMPANY_GROUPS");
export const getCompanyGroups = (payload) => makePayload(DEBT_VALUATION_GET_COMPANY_GROUPS.value, payload);
function* getCompanyGroupsSaga(payload) {
  const callback = handleCallback(payload);
  const url = "/debtValuation/getGroupsByCompanyId";
  yield requestSaga(DEBT_VALUATION_GET_COMPANY_GROUPS, url);
  yield callback();
}

export const DEBT_VALUATION_RESET_INITIAL_VALUES = generateDefaultActions("DEBT_VALUATION_RESET_INITIAL_VALUES");
export const DEBT_VALUATION_GET_DEBT_VALUATION_RESULTS = generateDefaultActions("DEBT_VALUATION_GET_DEBT_VALUATION_RESULTS");
export const getDebtValuationResults = (payload) => makePayload(DEBT_VALUATION_GET_DEBT_VALUATION_RESULTS.value, payload);
function* getDebtValuationResultsSaga(payload) {
  if (payload.isRefresh) {
    yield put(DEBT_VALUATION_RESET_INITIAL_VALUES.createSuccess(payload));
  }
  const callback = handleCallback(payload);
  const url = `/debtValuation/getResultsByCompanyId/${payload.isRefresh}`;
  yield requestSaga(DEBT_VALUATION_GET_DEBT_VALUATION_RESULTS, url);
  yield callback();
}
export const DEBT_VALUATION_POST_DEBT_VALUATION = generateDefaultActions("DEBT_VALUATION_POST_DEBT_VALUATION");
export const saveDebtValuation = (payload) => makePayload(DEBT_VALUATION_POST_DEBT_VALUATION.value, payload);
function* saveDebtValuationSaga(payload) {
  const callback = handleCallback(payload);
  const url = "/debtValuation/updateCompanyDebtValuation";
  yield requestSaga(DEBT_VALUATION_POST_DEBT_VALUATION, url, "POST", payload);
  yield callback();
}

export const DEBT_VALUATION_GET_CONFIG_ITEMS = generateDefaultActions("DEBT_VALUATION_GET_CONFIG_ITEMS");
export const getDebtValuationConfigItems = (payload) => makePayload(DEBT_VALUATION_GET_CONFIG_ITEMS.value, payload);
function* getDebtValuationConfigItemsSaga(payload) {
  const callback = handleCallback(payload);
  const url = "/configItemsByParents";
  const parentIds = [
    "90a3fb14-3365-4f1a-9f1c-10916388e9bf",
    "7a831d1a-2a33-4194-859e-2896212e4780",
    "10a60eb6-3641-4723-80fb-8bff9e9dd8ba",
    "8fb6d89d-4681-11e9-82f6-0242ac120002",
    "fd32a186-5c56-11ec-b9d7-98fa9bde2f84"
  ];

  yield requestSaga(DEBT_VALUATION_GET_CONFIG_ITEMS, url, "post", { parentIds });
  yield callback();
}

export const DEBT_VALUATION_GET_DEBT_VALUATION_SETTINGS_BY_LOAN = generateDefaultActions("DEBT_VALUATION_GET_DEBT_VALUATION_SETTINGS_BY_LOAN");
export const getDebtValuationSettingsByLoan = (payload) => makePayload(DEBT_VALUATION_GET_DEBT_VALUATION_SETTINGS_BY_LOAN.value, payload);
function* getDebtValuationSettingsByLoanSaga(payload) {
  const requestSaga = subKeySaga(payload.loanId);
  const url = `/debtValuation/getDebtValuationSettingsByLoan/${payload.loanId}`;
  yield requestSaga(DEBT_VALUATION_GET_DEBT_VALUATION_SETTINGS_BY_LOAN, url);
}

export const DEBT_VALUATION_GET_DV_SPREADS_BY_COMPANY = generateDefaultActions("DEBT_VALUATION_GET_DV_SPREADS_BY_COMPANY");
export const getDVSpreadsByCompany = (payload) => makePayload(DEBT_VALUATION_GET_DV_SPREADS_BY_COMPANY.value, payload);
function* getDVSpreadsByCompanySaga(payload) {
  const requestSaga = subKeySaga(payload.loanId);
  const url = "/debtValuation/debtValuationSettingsForCompany";
  yield requestSaga(DEBT_VALUATION_GET_DV_SPREADS_BY_COMPANY, url);
}
export const DEBT_VALUATION_UPDATE_DV_SPREADS_BY_COMPANY = generateDefaultActions("DEBT_VALUATION_UPDATE_DV_SPREADS_BY_COMPANY");
export const updateDVSpreadsByCompany = (payload) => makePayload(DEBT_VALUATION_UPDATE_DV_SPREADS_BY_COMPANY.value, payload);
function* updateDVSpreadsByCompanySaga(payload) {
  const { loanId, debtValuationId, spread } = payload;
  const url = "/debtValuation/debtValuationSettingsForCompany";
  yield requestSaga(DEBT_VALUATION_UPDATE_DV_SPREADS_BY_COMPANY, url, "post", { loanId, debtValuationId, spread });
}

export const DEBT_VALUATION_GET_RATE_AS_OF_DATE = generateDefaultActions("DEBT_VALUATION_GET_RATE_AS_OF_DATE");
export const getRatesAsOfForLoans = (payload) => makePayload(DEBT_VALUATION_GET_RATE_AS_OF_DATE.value, payload);
function* getRatesAsOfForLoansSaga(payload) {
  const url = `/debtValuation/getRatesAsOfForLoans/${payload.dealId}`;
  yield requestSaga(DEBT_VALUATION_GET_RATE_AS_OF_DATE, url);
}

const initialState = {
  debtValuationSetup: null,
  configItems: {},
  debtValuationResults: null,
  companyGroups: [{ id: -1, name: "All", label: "All" }],
  loanDebtValuationSettings: [],
  debtValuationSettingsForCompany: [],
  ratesAsOfForLoans: []
};

export function debtValuationReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case DEBT_VALUATION_RESET_INITIAL_VALUES.success:
      ToastInfo("Debt Valuation calculations are being re-processed. Please be patient");

      return defaultReturn(state, null, "debtValuationResults");

    case DEBT_VALUATION_GET_DEBT_VALUATION_SETTINGS_BY_LOAN.success:
      return fillDictionary(state, payload, "loanDebtValuationSettings", subKey);

    case DEBT_VALUATION_GET_DEBT_VALUATION_SETTINGS_BY_LOAN.failure:
      ToastError("Failed to get Company Groups");

      return state;
    case DEBT_VALUATION_GET_COMPANY_GROUPS.success:
      return defaultReturn(state, payload, "companyGroups");

    case DEBT_VALUATION_GET_COMPANY_GROUPS.failure:
      ToastError("Failed to get Company Groups");

      return state;

    case DEBT_VALUATION_GET_DEBT_VALUATION.success:
      return defaultReturn(state, payload, "debtValuationSetup");

    case DEBT_VALUATION_GET_DEBT_VALUATION.failure:
      ToastError("Failed to get Debt Valuation Setup");

      return state;

    case DEBT_VALUATION_POST_DEBT_VALUATION.success:
      ToastSuccess("Debt Valuation Setup saved successfully");

      return defaultReturn(state, payload, "debtValuationSetup");

    case DEBT_VALUATION_POST_DEBT_VALUATION.failure:
      ToastError("Failed to save Debt Valuation Setup");

      return state;

    case DEBT_VALUATION_GET_CONFIG_ITEMS.success:
      return defaultReturn(state, payload, "configItems");

    case DEBT_VALUATION_GET_CONFIG_ITEMS.failure:
      ToastError("Failed to get Debt Valuation Config Items");

      return state;

    case DEBT_VALUATION_GET_DEBT_VALUATION_RESULTS.success:
      ToastSuccess("Debt Valuation Results loaded successfully");

      return defaultReturn(state, payload, "debtValuationResults");

    case DEBT_VALUATION_GET_DEBT_VALUATION_RESULTS.failure:
      ToastError("Failed to get Debt Valuation Results");

      return state;

    case DEBT_VALUATION_UPDATE_DEBT_VALUATION_SETTINGS_FOR_LOAN.success:
      ToastSuccess("Debt Valuation Settings Updated");

      return state;

    case DEBT_VALUATION_UPDATE_DEBT_VALUATION_SETTINGS_FOR_LOAN.failure:
      ToastError("Failed to get Debt Valuation Results");

      return state;

    case DEBT_VALUATION_GET_DV_SPREADS_BY_COMPANY.success:
      return defaultReturn(state, payload, "debtValuationSettingsForCompany");

    case DEBT_VALUATION_GET_DV_SPREADS_BY_COMPANY.failure:
      ToastError("Failed to get Debt Valuation Settings");

      return state;

    case DEBT_VALUATION_UPDATE_DV_SPREADS_BY_COMPANY.success:
      ToastSuccess("Spread Updated");

      return state;

    case DEBT_VALUATION_UPDATE_DV_SPREADS_BY_COMPANY.failure:
      ToastError("Failed to Update Spread");

      return state;

    case DEBT_VALUATION_GET_RATE_AS_OF_DATE.success:
      return defaultReturn(state, payload, "ratesAsOfForLoans");

    case DEBT_VALUATION_GET_RATE_AS_OF_DATE.failure:
      ToastError("Failed to get Rates As Of For Loans");

      return state;
    default:
      return state;
  }
}

export function* debtValuationSaga() {
  yield takeLatest(DEBT_VALUATION_GET_DEBT_VALUATION.value, getDebtValuationSaga);
  yield takeLatest(DEBT_VALUATION_POST_DEBT_VALUATION.value, saveDebtValuationSaga);
  yield takeLatest(DEBT_VALUATION_GET_CONFIG_ITEMS.value, getDebtValuationConfigItemsSaga);
  yield takeLatest(DEBT_VALUATION_GET_DEBT_VALUATION_RESULTS.value, getDebtValuationResultsSaga);
  yield takeLatest(DEBT_VALUATION_GET_COMPANY_GROUPS.value, getCompanyGroupsSaga);
  yield takeLatest(DEBT_VALUATION_GET_RATE_AS_OF_DATE.value, getRatesAsOfForLoansSaga);
  yield takeEvery(DEBT_VALUATION_DOWNLOAD.value, downloadDebtValuationResultsSaga);
  yield takeEvery(DEBT_VALUATION_UPDATE_DEBT_VALUATION_SETTINGS_FOR_LOAN.value, updateDebtValuationSettingsForLoanSaga);
  yield takeEvery(DEBT_VALUATION_GET_DEBT_VALUATION_SETTINGS_BY_LOAN.value, getDebtValuationSettingsByLoanSaga);
  yield takeEvery(DEBT_VALUATION_DOWNLOAD_LOANID.value, downloadDebtValuationResultsByLoanIdSaga);
  yield takeEvery(DEBT_VALUATION_GET_DV_SPREADS_BY_COMPANY.value, getDVSpreadsByCompanySaga);
  yield takeEvery(DEBT_VALUATION_UPDATE_DV_SPREADS_BY_COMPANY.value, updateDVSpreadsByCompanySaga);
}
